import { FC, useMemo } from "react";
import useButton, { Props, ReceivedProps } from "./hook";
import { ButtonWrapper } from "./styles";
import { BUTTON_HEIGHT, BUTTON_HEIGHT_LARGE, FONT_SIZE } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";

const ButtonLayout: FC<Props> = ({
  className,
  label,
  icon,
  htmlType = false,
  loading = false,
  disabled = false,
  danger = false,
  missingRequire = false,
  onClick,
  onMouseDown,
  style,
  type = "primary",
  iconRight = false,
  height = 40,
  displaySize,
  typeButtonHeight = "small",
  ...rest
}) => {
  const buttonHeightConfig = useMemo(() => {
    if (typeButtonHeight === "large") {
      return BUTTON_HEIGHT_LARGE;
    }
    return BUTTON_HEIGHT;
  }, [typeButtonHeight]);

  const buttonHeight = displaySize ? buttonHeightConfig[displaySize] : height;
  const fontSize = FONT_SIZE[displaySize || DISPLAY_SIZES.SMALL];

  return (
    <ButtonWrapper
      $disabled={disabled}
      $missingRequire={missingRequire}
      $type={type}
      height={buttonHeight}
      danger={danger}
      disabled={disabled}
      loading={loading}
      className={className}
      onClick={onClick}
      onMouseDown={onMouseDown}
      {...(htmlType && { key: "submit", htmlType: "submit" })}
      style={{
        fontSize,
        ...style,
        ...(missingRequire && { cursor: "not-allowed", pointerEvents: "none" }),
      }}
      {...rest}
    >
      {!iconRight && icon}
      <span>{label}</span>
      {iconRight && icon}
      <div className="arrow" />
    </ButtonWrapper>
  );
};

const Button: FC<ReceivedProps> = (props) => (
  <ButtonLayout {...useButton(props)} />
);

export default Button;
